import { Page } from "v2/components";
import { AddressableSetup } from "./AddressableSetup";

export function Clients() {
  return (
    <Page title="Gestão de clientes">
      <Page.Tab name="Endereçabilidade">
        <AddressableSetup />
      </Page.Tab>
      <Page.Tab name="Convidar cliente" disabled />
    </Page>
  );
}
